import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { getEndpointWithParams } from 'queries/queries-utils'
import { sharedAssetsMutationKeys } from 'queries/sharedAssets/query-keys'
import {
  type SharedAssetsRequestAction,
  type SharedAssetsRequestsByActionPayload,
  type SharedAssetsRequestsPostResponse
} from 'types/api/sharedAssets/requests'

import type { AxiosError } from 'axios'

function postSharedAssetsRequestWithAction([endpoint, params]: ReturnType<
  typeof sharedAssetsMutationKeys.postSharedAssetsRequestWithAction
>) {
  return async (payload: SharedAssetsRequestsByActionPayload) => {
    const endpointWithParams = getEndpointWithParams(endpoint, params)

    const response = await agent.post<SharedAssetsRequestsPostResponse>(
      endpointWithParams,
      payload
    )

    return response.data
  }
}

export const usePostSharedAssetsRequestsWithAction = (
  action: SharedAssetsRequestAction,
  options?: Omit<
    MutationOptions<
      SharedAssetsRequestsPostResponse,
      AxiosError,
      SharedAssetsRequestsByActionPayload
    >,
    'mutationKey' | 'mutationFn'
  > & {
    requestingTeamId?: string
  }
) => {
  const { currentTeamId } = useAuth()

  const { requestingTeamId, ...queryOptions } = options ?? {}

  const teamId = requestingTeamId ?? currentTeamId

  const queryParams = { action, teamId }

  const mutationKey =
    sharedAssetsMutationKeys.postSharedAssetsRequestWithAction(queryParams)

  return useMutation({
    ...queryOptions,
    mutationKey,
    mutationFn: postSharedAssetsRequestWithAction(mutationKey)
  })
}
